import type { Ref } from 'react';

import type { BoardData } from '../../../pages/[[...board]]';
import { ErrorBoundary } from '../Error/ErrorBoundary';

import styles from './BoardSection.module.scss';
import { BoardSectionError } from './Section/BoardSectionError';
import { BoardSectionTile } from './Section/BoardSectionTile';
import { BoardSectionTitle } from './Section/BoardSectionTitle';

type Props = {
	boardSection: BoardData['sections'][number];
} & { ref?: Ref<HTMLElement | null> };

export function BoardSection({ ref, boardSection }: Props) {
	const isHighlight = boardSection.schema === 'HIGHLIGHT_3';

	return (
		<section className={styles.section} ref={ref} data-theme-area={isHighlight ? 'dark' : undefined}>
			<BoardSectionTitle section={boardSection} />

			<ErrorBoundary fallback={<BoardSectionError />}>
				<BoardSectionTile boardSection={boardSection} />
			</ErrorBoundary>
		</section>
	);
}
